import React from 'react';
import { Dropdown } from 'react-bootstrap';

const CategoryDropdown: React.FC<{
	items: {
		domId: string;
		name: string | null;
	}[];
	isDisabled?: boolean;
	ftuxHighlight?: boolean;
}> = ({ items, isDisabled = false, ftuxHighlight = false }) => {
	return (
		items && (
			<Dropdown>
				<Dropdown.Toggle
					id={`${ftuxHighlight ? 'dropdown-title-section' : ''}`}
					variant="dropdown"
					disabled={isDisabled}
					className={`${ftuxHighlight ? 'highlight-outline' : ''}`}
				>
					Go to category
				</Dropdown.Toggle>
				<Dropdown.Menu>
					{items.map((item, itemIndex) => {
						const { domId } = item;
						const name = item.name || '';
						return (
							<Dropdown.Item
								key={itemIndex}
								as="button"
								onClick={() => {
									// scroll to the section selected in the dropdown
									const mainContent = document.querySelector('#main-content');
									if (!mainContent) return;
									const helpCentreSection = mainContent.querySelector<HTMLDivElement>(domId);
									if (helpCentreSection?.offsetTop) {
										setTimeout(() => {
											mainContent.scrollTo({ top: helpCentreSection.offsetTop - 100, behavior: 'smooth' });
										}, 0);
									}
								}}
							>
								{name}
							</Dropdown.Item>
						);
					})}
				</Dropdown.Menu>
			</Dropdown>
		)
	);
};

export default CategoryDropdown;
